import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>404</h1>
        <h2 style={styles.subtitle}>Página no encontrada</h2>
        <p style={styles.text}>
          Lo sentimos, la página que buscas no existe o no tienes permisos para acceder.
        </p>
        <Link to="/" style={styles.button}>
          Volver al inicio
        </Link>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    fontFamily: "Arial, sans-serif",
  },
  content: {
    textAlign: "center",
    padding: "2rem",
  },
  title: {
    fontSize: "8rem",
    fontWeight: "bold",
    margin: "0",
    color: "#333",
  },
  subtitle: {
    fontSize: "2rem",
    margin: "1rem 0",
    color: "#666",
  },
  text: {
    fontSize: "1.1rem",
    margin: "1rem 0 2rem",
    color: "#888",
  },
  button: {
    display: "inline-block",
    padding: "0.8rem 2rem",
    backgroundColor: "#007bff",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "5px",
    fontSize: "1rem",
    transition: "background-color 0.3s",
  },
};

export default NotFound;
